export default __webpack_public_path__ + "static/media/mag.aa85101a.svg";